import { SerializedStyles } from '@emotion/core'
import cc from 'classcat'
import React from 'react'

import { reactClass } from '../../../utils'
import * as Styled from './styles'

export type ContainerProps = {
  children: React.ReactNode
  className?: string
  css?: SerializedStyles
}

export const Container = ({ children, className }: ContainerProps) => {
  return (
    <Styled.ContainerWrapper className={cc([className, reactClass('container')])}>{children}</Styled.ContainerWrapper>
  )
}
